import WhatsAppIcon from "./WhatsAppIcon";

const WA_URL =
  "https://wa.me/524424319100?text=Hola,%20necesito%20cotizar%20una%20reparaci%C3%B3n%20urgente%20de%20mi%20m%C3%A1quina%20CNC";

export default function WhatsAppFab() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Contactar por WhatsApp — Reparación urgente"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 group"
    >
      <span
        className="hidden md:flex items-center bg-[#0A1B35] text-white text-xs font-semibold uppercase tracking-wider px-4 py-2 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 -mr-2"
        style={{ borderRadius: "2px" }}
      >
        Cotizar por WhatsApp
      </span>
      <span className="relative">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <span className="relative w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-[#25D366] hover:bg-[#128C7E] flex items-center justify-center shadow-2xl transition-all duration-300 group-hover:scale-110">
          <WhatsAppIcon size={30} className="text-white lg:scale-110" />
        </span>
      </span>
    </a>
  );
}
